import React,{useState,useEffect,Fragment} from "react";

import Slider from "react-slick";
import "./Gallery.css";
import Aux from "../../hoc/Auxiliary";
import ImageGalleryItem from "./ImageGalleryItem";
import MessageGalleryItem from "./MessageGalleryItem";
import EmergencyModal from "./EmergencyModal";
import Icon from "./ImageIconItem"
const NextArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        // <div aria-label="Next" className={className + " fa fa-chevron-right"} aria-hidden="true" style={style} onClick={onClick} />
        <div aria-label="Next" className={className } aria-hidden="true" style={style} onClick={onClick} ><div  className=" galleryArrow arrowRight"></div></div>

        )
}
const PrevArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        // <div aria-label="Prev" className={className + " fa fa-chevron-left"} aria-hidden="true" style={style} onClick={onClick} />
        <div aria-label="Prev" className={className } aria-hidden="true" style={style} onClick={onClick}><div  className=" galleryArrow arrowLeft"></div></div>
    )
}

const Gallery = (props)=> {
    const settings ={
        dots: false,
        infinite: props.layout !== 'third',
        speed:700,
        slidesToShow: props.slidesToShow,
        slidesToScroll:1,
        centerMode: props.layout == 'third',
        swipeToSlide:true,
        nextArrow: <NextArrow/>,
        prevArrow: <PrevArrow/>,
        adaptiveHeight: false,
        centerPadding: "10px",
    };
    let items = null;
    let readMore = <div className="readMoreDiv imageGalleryLink">
        <a href={props.moreLink} className="readMoreLink">{props.moreTitle}<i className="fa fa-arrow-left"></i></a>
    </div>;
    if(props.layout == 'first' || props.layout == 'second'){
        if(!props.mobile){
            items=
            <Fragment>
           {readMore}
            <div className="col-12">
                <Slider {...settings}>
                    {props.items.map((item,index) => (
                        <ImageGalleryItem data={item} index={index} key={"ImageGalleryItem_"+index}/>
                    )) }
                </Slider>
            </div>
            </Fragment>
        }
        else{
            items = <Fragment>
            {props.items.map((item,index) =>(
                <Icon data={item}  key={"ImageGalleryItem_"+index} alt={item.moreTitle}></Icon>
            ))}
            {readMore}
            </Fragment>
            
        }
    } 
    else if(props.layout == 'third'){ //News
        let modal = null;
        if(props.emergency){
            modal=<EmergencyModal showModal={true} emergency={props.emergency}/>

            
        }
        if(!props.mobile){
            items=
            <Fragment>
           {readMore}
           {props.items.map((item,index) =>(
                 <MessageGalleryItem data={item} index={index} key={"MessageGalleryItem_"+index} moreLink={props.moreLink}/>
            ))}
            {modal}
            </Fragment>
        }
        else{
            items = <Fragment>
           
            <div className="col-12">
                <Slider {...settings}>
                    {props.items.map((item,index) => (
                         <MessageGalleryItem data={item} index={index} key={"MessageGalleryItem_"+index}  moreLink={props.moreLink}/>
                    )) }
                </Slider>
                {readMore}
            </div>
            {modal}
            </Fragment>
            
        }
    }
     
    return (
        <div className="row">
            {items}
        </div>
    );
}

export default Gallery;
